import styled from 'styled-components'

export const PackageSubTitle = styled.h2`
display: inline-block;
font-size: 20px;
font-weight: normal;
padding: 0px 32px;
background: #011627;
color: white;
`